import React from 'react';
import MainTemplate from '../mainTemplate';
import LogContainer from '../../shared/logs';
import { ReactTitle } from 'react-meta-tags';
import { useTranslation } from "react-i18next";

const PublicLogContainer = () => {
  const { t } = useTranslation();

  return <MainTemplate>
    <ReactTitle title={`${t('logs.meta.title')} - ${t('appName')}`} />
    <div className="client-log-container">
      <LogContainer />
    </div>
  </MainTemplate>;
}

export default PublicLogContainer;